import React from 'react';

import { connect } from 'react-redux';
import { loadEvent, loadBestPlayers } from 'dash-front/components/sm/pages/actions';
import SMStream from 'dash-front/components/sm/streams/SMStream2';
import _ from 'lodash';

class EventPlayerPerformanceSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {
        const { event, loadBestPlayers } = this.props;

        loadBestPlayers(event.homeId, 'homeBestPlayers');
        loadBestPlayers(event.awayId, 'awayBestPlayers');
    };

    state = {};

    /// how to get best team player???
    render() {
        const { event } = this.props;

        return (
            <div>
                {['home', 'away'].map(side => {
                    const teamId = event[`${side}Id`];
                    const teamName = event[`${side}Name`];
                    const players = this.props[`${side}BestPlayers`] || [];

                    return (
                        <SMStream
                            key={side}
                            smWidgets={_.flatten(
                                players.map(player => [
                                    {
                                        name: 'PlayerLatestMatchesFormSMWidget',
                                        groupTitle: `${player.playerName} in ${event.tournamentName}`,
                                        groupKey: player.playerId,
                                        props: {
                                            playerId: player.playerId,
                                            teamId,
                                            incidentType: 'goals+assists',
                                            ttIds: JSON.stringify([event.tournamentTemplateId]),
                                        },
                                    },
                                    {
                                        name: 'PlayerLatestMatchesFormSMWidget',
                                        groupTitle: `${player.playerName}`,
                                        groupKey: player.playerId,
                                        props: {
                                            playerId: player.playerId,
                                            teamId,
                                        },
                                    },
                                    {
                                        name: 'PlayerProfileOpta',
                                        groupTitle: `${player.playerName}`,
                                        groupKey: player.playerId + 'pp',
                                        props: {
                                            playerId: player.playerId,
                                            teamId,
                                            currentSeason: true,
                                            seasonId: event.tournamentId,
                                            tournamentId: event.tournamentTemplateId,
                                        },
                                    },
                                    {
                                        name: 'PlayerProfileOpta',
                                        groupTitle: `${player.playerName}`,
                                        groupKey: player.playerId + 'pp',
                                        props: {
                                            playerId: player.playerId,
                                            teamId,
                                            tournamentId: event.tournamentTemplateId,
                                        },
                                    },
                                    {
                                        name: 'PlayerProfileOpta',
                                        groupTitle: `${player.playerName}`,
                                        groupKey: player.playerId + 'pp',
                                        props: {
                                            playerId: player.playerId,
                                            teamId,
                                        },
                                    },
                                    {
                                        name: 'PlayerProfileAdvSMWidget',
                                        groupTitle: `${player.playerName} Full profile`,
                                        groupKey: player.playerId + 'pa',
                                        props: {
                                            playerId: player.playerId,
                                            teamId,
                                        },
                                    },
                                ]),
                            )}
                            title={`Best players ${teamName}`}
                        />
                    );
                })}
            </div>
        );
    }
}

export default connect(
    state => ({
        event: state.smBrowser.event,
        homeBestPlayers: state.smBrowser.homeBestPlayers,
        awayBestPlayers: state.smBrowser.awayBestPlayers,
    }),
    dispatch => ({
        loadBestPlayers: (teamId, side) => dispatch(loadBestPlayers(teamId, side)),
    }),
)(EventPlayerPerformanceSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventPlayerPerformanceSMB.js
 **/